import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import JobArchitectureApp from './JobArchitectureApp.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <JobArchitectureApp />
  </StrictMode>,
)
